"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const uuid_1 = require("uuid");
const HBIcon_1 = __importDefault(require("../components/HBIcon/HBIcon"));
function QuestionGuestsSvg(props) {
    const id0 = (0, react_1.useMemo)(() => (0, uuid_1.v4)(), []);
    const id1 = (0, react_1.useMemo)(() => (0, uuid_1.v4)(), []);
    return react_1.default.createElement("svg", Object.assign({ xmlns: "http://www.w3.org/2000/svg", xmlnsXlink: "http://www.w3.org/1999/xlink", width: 68, height: 43, viewBox: "0 0 68 43" }, props),
        react_1.default.createElement("defs", null,
            react_1.default.createElement("path", { id: `questionguests-${id0}`, d: "M9.105 10.79c2.326 0 4.21-1.886 4.21-4.211s-1.884-4.21-4.21-4.21c-2.325 0-4.21 1.885-4.21 4.21s1.885 4.21 4.21 4.21zm0-10.106C12.361.684 15 3.324 15 6.58c0 2.032-1.028 3.824-2.592 4.884 2.51 1.07 4.394 3.325 4.95 6.063H15.63c-.748-2.905-3.386-5.052-6.525-5.052-3.139 0-5.776 2.147-6.524 5.052H.853c.555-2.738 2.44-4.993 4.95-6.065-1.564-1.058-2.592-2.85-2.592-4.882C3.21 3.323 5.85.684 9.105.684z" }),
            react_1.default.createElement("path", { id: `questionguests-${id1}`, d: "M9.105 10.79c2.326 0 4.21-1.886 4.21-4.211s-1.884-4.21-4.21-4.21c-2.325 0-4.21 1.885-4.21 4.21s1.885 4.21 4.21 4.21zm0-10.106C12.361.684 15 3.324 15 6.58c0 2.032-1.028 3.824-2.592 4.884 2.51 1.07 4.394 3.325 4.95 6.063H15.63c-.748-2.905-3.386-5.052-6.525-5.052-3.139 0-5.776 2.147-6.524 5.052H.853c.555-2.738 2.44-4.993 4.95-6.065-1.564-1.058-2.592-2.85-2.592-4.882C3.21 3.323 5.85.684 9.105.684z" })),
        react_1.default.createElement("g", { fill: "none", fillRule: "evenodd" },
            react_1.default.createElement("rect", { width: 54, height: 14, x: 7, y: 14, fill: "#597EFF", fillRule: "nonzero", opacity: 0.1, rx: 2 }),
            react_1.default.createElement("g", { transform: "matrix(-1 0 0 1 57 12)" },
                react_1.default.createElement("use", { fill: "#B2C3FF", fillRule: "nonzero", xlinkHref: `#questionguests-${id0}` })),
            react_1.default.createElement("g", { transform: "matrix(-1 0 0 1 43 12)" },
                react_1.default.createElement("use", { fill: "#B2C3FF", fillRule: "nonzero", xlinkHref: `#questionguests-${id1}` })),
            react_1.default.createElement("path", { fill: "#B2C3FF", d: "M60 16v2h2v2h-2v2h-2v-2h-2v-2h2v-2h2z" }),
            react_1.default.createElement("path", { fill: "#597EFF", fillRule: "nonzero", d: "M14 20v2h-2v-2h2zm4 0v2h-2v-2h2zm4 0v2h-2v-2h2z", opacity: 0.4 })));
}
function QuestionGuests(_a) {
    var { svgProps } = _a, props = __rest(_a, ["svgProps"]);
    return react_1.default.createElement(HBIcon_1.default, Object.assign({}, props),
        react_1.default.createElement(QuestionGuestsSvg, Object.assign({}, svgProps)));
}
exports.default = QuestionGuests;
//# sourceMappingURL=QuestionGuests.js.map